import { MapStyle } from '../../../../../../../../components/Maps/constants/constants';
import { Text } from '../../../../../../../../components/Text/Text';
import { trackEvent } from '@domain/analytics/trackEvent';
import { reportMykissClientError } from '@lib/errors/client';

import hybridStyleBackground from './assets/hybrid.png';
import { MapStyleDetails } from './assets/MapStyleDetails';
import terrainStyleBackground from './assets/terrain.png';

interface IProps {
  mapStyle: MapStyle;
  selectedMapStyle: MapStyle;
  onMapStyleClick: (newStyle: MapStyle) => void;
}

/*
NB: there are both a 'satellite' and a 'hybrid satellite' map in mapbox,
we currently use the hybrid one (satellite + roads) but just calling
it hybrid for our users, without the context of the satelite one, wasn't
making it clear enough. For clarity Hybrid has here been renamed Satellite
only for the user.
*/
export const MapStyleButton = ({ mapStyle, selectedMapStyle, onMapStyleClick }: IProps) => {
  const backgroundImage =
    mapStyle === 'terrain' ? terrainStyleBackground.src : hybridStyleBackground.src;
  const title = mapStyle === 'terrain' ? 'Terrain' : 'Satellite';

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <button
        type="button"
        className={`w-full rounded-md border-2 ${
          selectedMapStyle !== mapStyle && 'border-lake-fog'
        }`}
        data-testid="mapStyleButton"
        onClick={() => {
          try {
            onMapStyleClick(mapStyle);
          } catch (error) {
            reportMykissClientError(error);
          }
          trackEvent({
            name: 'mykiss_explore_style_toggled',
            properties: { style_type: mapStyle === 'terrain' ? 'terrain' : 'hybrid' },
          });
        }}
      >
        <div
          style={{ backgroundImage: `url(${backgroundImage})` }}
          className="overflow-hidden rounded-md border-2 border-white bg-cover"
          data-testid={`mapStylePreview${title}`}
        >
          <MapStyleDetails />
        </div>
      </button>
      <Text variant="sm" className="mt-1 mb-0">
        {title}
      </Text>
    </div>
  );
};
